export const RULE_OPTIONS = [
  {
    name: 'All products',
    value: 'ALL',
  },
  {
    name: 'Individual products',
    value: 'INDIVIDUAL',
  },
  {
    name: 'Conditions',
    value: 'CONDITIONS',
  },
];
